import ViewerContainer from 'app/containers/ViewerContainer/ViewerContainer';
import { PDF_ENGINE } from 'core/variables/constant';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { withTranslation } from 'react-i18next';
import consumptionsv2 from '../../../../store/viewer';

const AudioPlayer = ({ guid, contentUrl, contentName, contentDescription, userGuid, measureProgress, jobStatus, updateJob, t, contentGuid }) => {
  const [trackProgress, setTrackProgress] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [consumptionGuid, setConsumptionGuid] = useState('');
  const [consumptionSessionGuid, setConsumptionSessionGuid] = useState('');
  const [isReady, setIsReady] = useState(false);
  const [isScrubbing, setIsScrubbing] = useState(false);

  // Refs
  const audioRef = useRef(new Audio(contentUrl));
  const intervalRef = useRef();

  // Destructure for conciseness
  const { duration } = audioRef.current;

  useEffect(() => {
    if (isPlaying) {
      audioRef.current.play();
      audioRef.current.currentTime = trackProgress;
      startTimer();
    } else {
      clearInterval(intervalRef.current);
      audioRef.current.pause();
    }
  }, [isPlaying]);

  useEffect(() => {
    // Pause and clean up on unmount
    return () => {
      navigator.mediaSession.setActionHandler('play', function () {});
      audioRef.current.pause();
      clearInterval(intervalRef.current);
    };
  }, []);

  useEffect(() => {
    if (guid && duration && measureProgress) {
      consumptionsv2(
        {
          type: 'INIT_SESION_CONSUMPTION',
          params: {
            guid: null,
            person_guid: userGuid,
            content_guid: guid,
            status: 'inProgress',
            type: 'audio',
            progress: trackProgress,
            progress_ends: duration,
          },
        },
        (result) => {
          setConsumptionGuid(result.guid);
          setTrackProgress(result.last || 0);
          setConsumptionSessionGuid(result.session_guid);

          if ((result.status === 'finished' || result.progress > 0.8) && !jobStatus) {
            updateJob(guid, true);
          }
        }
      );
    }
  }, [guid, duration]);

  useEffect(() => {
    if (consumptionGuid && consumptionGuid.length > 0) {
      setIsReady(true);
      if (isPlaying) {
        setIsPlaying(true);
      }
    }
  }, [consumptionGuid]);

  const startTimer = () => {
    // Clear any timers already running
    clearInterval(intervalRef.current);

    intervalRef.current = setInterval(() => {
      if (audioRef.current.ended) {
        setIsPlaying(false);
        setTrackProgress(0);
        audioRef.current.pause();
        clearInterval(intervalRef.current);
      } else {
        setTrackProgress(audioRef.current.currentTime);
      }
    }, [1000]);
  };

  useEffect(() => {
    if (consumptionGuid && !isScrubbing && consumptionSessionGuid) {
      consumptionsv2(
        {
          type: 'UPDATE_CONSUMPTION',
          params: {
            id: 0,
            consumption_guid: consumptionGuid,
            content_guid: guid,
            session_guid: consumptionSessionGuid,
            progress_start: audioRef.current.currentTime - 1,
            progress_end: audioRef.current.currentTime,
            started_at: new Date() - 1000,
            ended_at: Date.now(),
          },
        },
        (result) => {
          if (measureProgress && result.progress > 0.8 && (!jobStatus || jobStatus === 'pending')) {
            updateJob(guid, true);
          }
        }
      );
    }
  }, [trackProgress, isScrubbing]);

  const onScrub = (value) => {
    // Clear any timers already running
    clearInterval(intervalRef.current);
    audioRef.current.currentTime = value;
    setTrackProgress(audioRef.current.currentTime);
    setIsScrubbing(true);
  };

  const onScrubEnd = () => {
    // If not already playing, start
    setIsScrubbing(false);
    if (!isPlaying) {
      setIsPlaying(true);
    }
    startTimer();
  };

  return (
    <div className="preview-content__audio">
      <ViewerContainer
        contentGuid={contentGuid}
        showEmbed
        pdfLibrary={PDF_ENGINE.NUTRIENT}
        standalone={true}
        externalContentUrl={contentUrl}
        showHeader={false}
      />
      {/* <span className="preview-content__name">{contentName}</span> */}
      {/* <span className="preview-content__description">{contentDescription}</span> */}
      {/* {content && <span className="preview-content__duration">{content.contentDurationTime}</span>} */}
      {/* <div className="preview-content__audio-icons">
        <Button
          accessibilityOnly
          icon={isPlaying && !isReady ? 'loading' : `${isPlaying ? 'pause' : 'play'}-circle`}
          iconSize="xl"
          onClick={() => setIsPlaying(!isPlaying)}
          ariaLabel={t(`buttons:${isPlaying ? 'Pause audio' : 'Play audio'}`)}
        />
        <div className="preview-content__audio-bar-container"> */}
      {/* <div className="preview-content__audio-bar"></div>
          <div className="preview-content__audio-bar-circle" style={{ marginLeft: currentPercentage }}></div> */}
      {/* <input
            type="range"
            value={trackProgress}
            // step={0.01}
            min={0}
            max={duration ? duration : `${duration}`}
            className="preview-content__audio-bar"
            onChange={(e) => onScrub(e.target.value)}
            onMouseUp={onScrubEnd}
            onKeyUp={onScrubEnd}
          />
        </div> */}
      {/* </div> */}
    </div>
  );
};

AudioPlayer.propTypes = {
  onShowVisor: PropTypes.func,
  measureProgress: PropTypes.bool,
};

AudioPlayer.defaultProps = {
  onShowVisor: function () {},
  measureProgress: true,
};

export default withTranslation(['buttons'])(AudioPlayer);
